"use strict";
/**
 * Internal domain events (TZ §58) and the realtime channel contract (TZ §12).
 *
 * The backend publishes a domain event once, and every listener — Telegram
 * notifier, KDS push, analytics, customer notification — reacts to it. Nothing
 * calls the Telegram API from inside an HTTP handler (TZ §57).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeEvent = exports.RealtimeRoom = exports.DomainEvent = void 0;
/* -------------------------------------------------------------------------- */
/* Event names                                                                */
/* -------------------------------------------------------------------------- */
exports.DomainEvent = {
    ORDER_CREATED: 'order.created',
    ORDER_ACCEPTED: 'order.accepted',
    ORDER_PREPARING: 'order.preparing',
    ORDER_READY: 'order.ready',
    ORDER_STATUS_CHANGED: 'order.status_changed',
    ORDER_CANCELLED: 'order.cancelled',
    ORDER_DELIVERED: 'order.delivered',
    PAYMENT_RECEIVED: 'payment.received',
    PAYMENT_FAILED: 'payment.failed',
    PAYMENT_REFUNDED: 'payment.refunded',
    COURIER_ASSIGNED: 'courier.assigned',
    COURIER_STATUS_CHANGED: 'courier.status_changed',
    COURIER_LOCATION_UPDATED: 'courier.location_updated',
    DELIVERY_STATUS_CHANGED: 'delivery.status_changed',
    CASH_SHIFT_OPENED: 'cash_shift.opened',
    CASH_SHIFT_CLOSED: 'cash_shift.closed',
    CASH_HANDOVER_DECLARED: 'cash_handover.declared',
    CASH_HANDOVER_CONFIRMED: 'cash_handover.confirmed',
    WAITER_CALLED: 'waiter.called',
    PRODUCT_STOP_LISTED: 'product.stop_listed',
};
/* -------------------------------------------------------------------------- */
/* Realtime (WebSocket) contract                                              */
/* -------------------------------------------------------------------------- */
/**
 * Rooms a socket can subscribe to. The gateway derives the tenant from the
 * token and refuses any room whose tenant does not match, so a client cannot
 * subscribe its way into another company's traffic.
 */
exports.RealtimeRoom = {
    /** Everything happening in one branch — admin dashboards. */
    branch: (branchId) => `branch:${branchId}`,
    /** Kitchen display for one branch, optionally narrowed to a station. */
    kitchen: (branchId) => `kitchen:${branchId}`,
    /** POS terminals of one branch. */
    pos: (branchId) => `pos:${branchId}`,
    /** A single order — used by the customer's order-tracking screen. */
    order: (orderId) => `order:${orderId}`,
    /** One courier's own jobs. */
    courier: (courierId) => `courier:${courierId}`,
    /** Dispatcher map of every courier in a tenant. */
    dispatch: (tenantId) => `dispatch:${tenantId}`,
};
/** Messages the server pushes to clients. */
exports.RealtimeEvent = {
    ORDER_CREATED: 'order:created',
    ORDER_UPDATED: 'order:updated',
    ORDER_STATUS: 'order:status',
    KITCHEN_TICKET_CREATED: 'kitchen:ticket_created',
    KITCHEN_TICKET_UPDATED: 'kitchen:ticket_updated',
    COURIER_LOCATION: 'courier:location',
    COURIER_JOB_ASSIGNED: 'courier:job_assigned',
    WAITER_CALL: 'waiter:call',
    STOP_LIST_CHANGED: 'menu:stop_list_changed',
};
//# sourceMappingURL=events.js.map